import { getObjectStoreIdString } from "../../decorators/StoreIdHelper";
import { ColumnMatcher } from "../../models/ColumnMatcher";
import { DocFieldConfig } from "../../models/config/DocFieldConfig";
import { TableConfig } from "../../models/config/TableConfig";
import Model from "../../models/Model";
import { TableModel } from "../../models/TableModel";
import {
  validationRuleSetToValidationRules,
  validationRulesToValidationRuleSet,
} from "../../models/validation/ValidationRuleSet";
import { TTValidationTableRequireAllLabel } from "../tooltips/ConfigurationTooltips";
import { ValidationEditorHeader } from "../validation/ValidationEditorHeader";
import { ValidationEditorList } from "../validation/ValidationEditorList";

export { ColumnValidationList };
type Props = {
  acceleratorDocUuid: string;
  model: Model;
  tableModel: TableModel;
  tableConfig: TableConfig;
  /** Open field name or '' */
  open: string | undefined;
  setOpen: (openField: string | undefined) => void;
  modelChanged: (model: TableModel) => void;
};
const ColumnValidationList = (props: Props) => {
  const columnMatchers = props.tableConfig.columnNames
    .filter((c) => !c.actualHidden)
    .map((column) => props.tableModel.getColumn(column))
    .filter((c): c is ColumnMatcher => c != undefined);
  // .reverse();

  return (
    <div>
      {columnMatchers.map((columnMatcher) => {
        const columnConfig = props.tableConfig.getDocFieldConfig(
          columnMatcher.columnName,
        );
        return (
          <ValidationEditorList
            mainListTitle={"Template Validation Rules"}
            key={`${getObjectStoreIdString(props.model)}-${props.model.docType}-${props.tableModel.name}-${columnMatcher.getMatcherId()}-${columnMatcher.columnName}`}
            fieldName={columnMatcher.columnName}
            validationOperator={
              props.tableModel.getValidationRuleSet(columnMatcher.columnName)
                .clientValidationOperator
            }
            rules={validationRuleSetToValidationRules(
              props.tableModel.getValidationRuleSet(columnMatcher.columnName),
            )}
            effectiveRulesOperator={
              columnConfig?.validator.clientValidationOperator ?? "OR"
            }
            effectiveRules={columnConfig?.validator.validationRules ?? []}
            update={(rules, operator) => {
              props.tableModel.setValidationRuleSet(
                columnMatcher.columnName,
                validationRulesToValidationRuleSet(
                  columnMatcher.columnName,
                  rules,
                  operator,
                ),
              );
              // update Model Transform Rules
              props.modelChanged(props.tableModel);
            }}
            testValue={undefined}
            open={props.open === columnMatcher.columnName}
            setOpen={(o) =>
              props.setOpen(o ? columnMatcher.columnName : undefined)
            }
          />
        );
      })}
    </div>
  );
};
